// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"EX-z","sponsoredTooltipWrapper":"FX-z","sponsoredTooltip":"GX-z","newCard":"HX-z"};